import { authSlice } from '@features/auth/store/auth.slice';
import { eventsSlice } from '@features/events/store/events.slice';
import { gameficationSlice } from '@features/gamefication/store/gamefication.slice';
import { layoutSlice } from '@features/layout/store/layout.slice';
import { segmentsSlice } from '@features/segments/store/segments.slice';
import { combineReducers } from '@reduxjs/toolkit';

export const rootReducer = combineReducers({
  [authSlice.name]: authSlice.reducer,
  [layoutSlice.name]: layoutSlice.reducer,
  [gameficationSlice.name]: gameficationSlice.reducer,
  [segmentsSlice.name]: segmentsSlice.reducer,
  [eventsSlice.name]: eventsSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
